module.exports = __webpack_public_path__ + "img/stopped_at.f9a730d0.svg";